import React, { useEffect } from 'react';

import CreateCauzeView from './CreateCauzeView';
import useCreateCauze from 'hooks/useCreateCauze';
import withAuthRequired from 'behaviors/withAuthRequired';
import useDashboardStore from 'stores/DashboardStore';

const CharityCreateCauzeView = ({ charityId, eventId }) => {
  const { setProps } = useDashboardStore();
  const { cauzeLoaded } = useCreateCauze({
    userContext: { charityId },
    eventId,
  });

  useEffect(() => {
    setProps({
      size: 'full',
    });
  }, []);

  return (
    <CreateCauzeView
      userContext={{ charityId }}
      eventId={eventId}
      cauzeLoaded={cauzeLoaded}
    />
  );
};

export default withAuthRequired(CharityCreateCauzeView, {
  entityType: 'CHARITY',
});
